import { useStreamingGatewayApi } from './streamingGatewayApi';

export interface LlmModel {
  id: string;
  provider: string;
  displayName: string;
  supportsPromptCaching: boolean;
  inputPricePerMillionTokens: number;
  outputPricePerMillionTokens: number;
}

export function useLlmModelsService() {
  const streamingGatewayApi = useStreamingGatewayApi();

  const getModels = async (): Promise<LlmModel[]> => {
    return await streamingGatewayApi.get('/models') as LlmModel[];
  };

  return {
    getModels,
  };
}
